import { ContactManagementConfigContext } from '../../../../ui/providers';
import { usePublicDataGet } from '@juvare/platform-sdk-react/ui/hooks/usePublicDataGet';
import React from 'react';
export function useAccountSections(page, onFilterAccountSections) {
    const { appName } = React.useContext(ContactManagementConfigContext);
    const response = usePublicDataGet('accountSections', appName);
    return Object.assign(Object.assign({}, response), { data: response.data ? filterAccountSections(response.data, page, onFilterAccountSections) : undefined, reload: response.mutate });
}
/**
 * Note: Providing an onFilterAccountSections callback is intended as a temporary solution to
 * extend filtering behavior. This should be refactored after PFCM-1602 implementation with PFCM-1620 by using the
 * UI configuration extensions.
 *
 * TODO(PFCM-1620): Replace the additional filtering callback with UI configuration–based extensions.
 */
export function filterAccountSections(sections, page, onFilterAccountSections) {
    const filteredSections = sections.filter((section) => { var _a; return (_a = section.columns.showInPages) === null || _a === void 0 ? void 0 : _a.includes(page); });
    return onFilterAccountSections ? onFilterAccountSections(filteredSections) : filteredSections;
}
